import { ChangeDetectionStrategy, Component, SkipSelf } from '@angular/core';
import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { RadioButtonInputComponent } from '../../../../ui/form-components/radio-button-input/radio-button-input.component';

@Component({
  selector: 'app-written-cheque-card',
  templateUrl: './written-cheque-card.component.html',
  styleUrls: ['./written-cheque-card.component.scss'],
  standalone: true,
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]]
    }
  ],
  imports: [RadioButtonInputComponent, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WrittenChequeCardComponent {}
